<template>
  <Page color="success" :title="title">
    <v-card v-if="pensenData" :loading="loading" class="mb-4">
      <v-system-bar> Informationen </v-system-bar>
      <v-card-text>
        <p>Kürzel: {{ employment.teacher.code }}</p>
        <p>Abteilung: {{ employment.division.code }}</p>
        <p>Auszahlung: {{ employment.payment }}%</p>
        <p>
          Pensum: {{ employment.employmentMin }} –
          {{ employment.employmentMax }}%
        </p>
        <p>Unterricht: {{ percentage }}%</p>
      </v-card-text>
    </v-card>

    <v-alert
      prominent
      type="info"
      text
      v-if="wishData.length == 0"
      :loading="loading"
      class="mb-4"
    >
      <v-row align="center">
        <v-col class="grow">
          Es ist kein Wunschformular für das Semester
          {{ term.fullText }} vorhanden.<br />Möchtet du ein neues
          Wunschformular erzeugen?
        </v-col>
        <v-col class="shrink">
          <v-btn depressed color="info" @click="createWishForm">erzeugen</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <template v-else>
      <v-alert
        prominent
        type="error"
        text
        v-if="!wish.submitted"
        :loading="loading"
        class="mb-4"
      >
        <v-row align="center">
          <v-col class="grow">
            Du hast das Wunschformular für das Semester
            {{ term.fullText }} noch nicht freigegeben.<br />
            Bitte überprüfe deine Angaben und gib das Formular mit dem Button
            unten an der Seite frei, damit die Stundenplanerstellung
            durchgeführt werden kann.
          </v-col>
        </v-row>
      </v-alert>
      <v-alert
        prominent
        type="success"
        text
        v-else
        :loading="loading"
        class="mb-4"
      >
        <v-row align="center">
          <v-col class="grow">
            Du hast das Wunschformular für das Semester
            {{ term.fullText }} freigegeben.
          </v-col>
        </v-row>
      </v-alert>

      <CourseWishes
        :coursesAvailable="courses"
        :wishId="wish.id"
        v-if="pensenData"
        :loading="loading"
        class="mb-4"
        :disabled="wish.submitted"
      />

      <v-card v-if="pensenData" :loading="loading" class="mb-4">
        <v-system-bar> freie Halb-/Ganztage </v-system-bar>
        <v-card-text>
          Du hast im nächsten Semester ein Unterrichtspensum von
          {{ percentage }}%. Das Stundenplanprogramm wird dir entsprechend
          automatisch {{ freeHalfDays }} Halbtage freihalten Welche Kombination
          aus freien Halb- und Ganztage wäre dir am liebsten?
        </v-card-text>

        <v-card-text>
          <v-slider
            :key="`slide-half-${key}`"
            :label="`freie Halbtage: ${wishFreeHalfDays}`"
            :hint="`verfügbare Halbtage: ${maxFreeHalfDays - wishFreeHalfDays}`"
            :value="wishFreeHalfDays"
            :max="freeHalfDays"
            @change="setFreeHalfDays"
            step="1"
            thumb-label
            persistent-hint
            ticks
            :rules="ruleMaxHalfDays"
            :disabled="wish.submitted"
          >
          </v-slider>
        </v-card-text>

        <v-card-text>
          <v-slider
            :key="`slide-full-${key}`"
            :label="`freie Ganztage: ${wishFreeFullDays}`"
            :hint="`verfügbare Ganztage: ${maxFreeFullDays - wishFreeFullDays}`"
            :value="wishFreeFullDays"
            @change="setFreeFullDays"
            :max="Math.floor(freeHalfDays / 2)"
            step="1"
            thumb-label
            persistent-hint
            ticks
            :rules="ruleMaxFullDays"
            :disabled="wish.submitted"
          >
          </v-slider>
        </v-card-text>
      </v-card>

      <v-toolbar flat>
        <v-switch
          class="mr-4 ml-auto"
          label="Zwingende Sperrungen"
          v-model="forcedSlots"
          :disabled="hasForcedSlots || wish.submitted"
        >
        </v-switch>
        <v-switch
          class="mr-auto"
          label="Wünsche"
          v-model="unForcedSlots"
          :disabled="hasUnforcedSlots || wish.submitted"
        >
        </v-switch>
      </v-toolbar>

      <v-card
        v-if="pensenData"
        v-show="hasForcedSlots || forcedSlots"
        :loading="loading"
        class="mb-4"
      >
        <v-system-bar>Zwingende Sperrungen</v-system-bar>

        <v-card-text
          >Gemäss deinem Pensum kannst du max. {{ maxLessonsBlocked }} Lektionen
          sperren.
        </v-card-text>
        <TableBlocked
          forced
          :wishId="wish.id"
          @loaded="hasForcedSlots = $event"
          :disabled="wish.submitted"
        />
      </v-card>

      <v-card
        v-if="pensenData"
        v-show="hasUnforcedSlots || unForcedSlots"
        :loading="loading"
        class="mb-4"
      >
        <v-system-bar>Gewünschte Sperrungen</v-system-bar>

        <v-card-text
          >Gemäss deinem Pensum kannst du max. {{ maxLessonsBlocked }} Lektionen
          sperren.
        </v-card-text>
        <TableBlocked
          :wishId="wish.id"
          @loaded="hasUnforcedSlots = $event"
          :disabled="wish.submitted"
        />
      </v-card>
      <v-card v-if="pensenData" :loading="loading" class="mb-4">
        <v-system-bar> Bestätigung </v-system-bar>
        <v-card-text>
          Ich bestätige, dass ich die Angaben zu meinen Stundenplanwünschen und
          Sperrungen korrekt gemacht habe.
        </v-card-text>
        <v-card-actions
          ><v-spacer></v-spacer>
          <v-btn
            depressed
            color="error"
            @click="unsubmit"
            :disabled="!wish.submitted"
            >freigabe rückgängig machen</v-btn
          >

          <v-btn
            depressed
            color="primary"
            @click="submit"
            :disabled="wish.submitted"
            >freigeben</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </Page>
</template>
<script>
import { defineComponent } from "vue";

import CourseWishes from "./components/CourseWishes.vue";
import TableBlocked from "./components/TableBlocked.vue";

export default defineComponent({
  components: { CourseWishes, TableBlocked },

  data() {
    return {
      courses: [],
      pensenData: null,
      wishData: [],
      loading: false,
      forcedSlots: false,
      unForcedSlots: false,
      hasForcedSlots: false,
      hasUnforcedSlots: false,
      key: 0,
    };
  },
  computed: {
    wish() {
      if (!this.wishData || this.wishData.length === 0) return {};
      return this.wishData[0];
    },
    employment() {
      if (!this.pensenData) return {};

      if (this.pensenData.term.semester.code == "1") {
        return {
          ...this.pensenData.employment,
          payment: this.pensenData.employment.payment1,
        };
      }
      if (this.pensenData.term.semester.code == "2") {
        return {
          ...this.pensenData.employment,
          payment: this.pensenData.employment.payment2,
        };
      }
      return {};
    },

    freeHalfDays() {
      if (!this.pensenData) return {};
      return Math.floor((100 - this.percentage) / 10);
    },
    percentage() {
      if (!this.pensenData) return 0;
      let p = 0;
      if (this.pensenData.term.semester.code == "1") {
        p = this.pensenData.percentage1;
      }
      if (this.pensenData.term.semester.code == "2") {
        p = this.pensenData.percentage2;
      }
      return p.toFixed(0);
    },
    term() {
      if (!this.pensenData) return {};
      return this.pensenData.term;
    },
    title() {
      return "Stundenplanwünsche " + (this.term ? this.term.fullText : "");
    },
    maxFreeHalfDays() {
      if (!this.pensenData) return 0;
      return this.freeHalfDays - this.wishFreeFullDays * 2;
    },
    ruleMaxHalfDays() {
      return [(v) => v <= this.maxFreeHalfDays || "zuviele freie Halbtage"];
    },
    ruleMaxFullDays() {
      return [(v) => v <= this.maxFreeFullDays || "zuviele freie Ganztage"];
    },
    maxFreeFullDays() {
      if (!this.pensenData) return 0;
      return Math.floor((this.freeHalfDays - this.wishFreeHalfDays) / 2);
    },
    maxLessonsBlocked() {
      if (!this.pensenData) return 0;
      return 26 - this.courses.reduce((acc, c) => acc + c.lessons, 0);
    },
    wishFreeHalfDays() {
      if (!this.wishData || this.wishData.length === 0) return 0;
      return this.wishData[0].halfdays;
    },
    wishFreeFullDays() {
      if (!this.wishData || this.wishData.length === 0) return 0;
      return this.wishData[0].fulldays;
    },
  },
  watch: {},
  methods: {
    async createWishForm() {
      await this.apiPost({
        resource: "teacher/wish",
        data: {
          teacher: this.employment,
          term: this.term.id,
          employment: this.percentage,
        },
      });
      await this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.wishData = await this.apiList({
        resource: "teacher/wish",
      });
      this.pensenData = await this.apiList({
        resource: "pensen/info",
      });

      if (this.pensenData.term.semester.code == "1") {
        this.courses = this.data.courses.map((c) => ({
          ...c,
          teachers: c.teachers1,
          lessons: c.lessons1,
          percentage: c.percentage1,
        }));
      }
      if (this.pensenData.term.semester.code == "2") {
        this.courses = this.pensenData.courses.map((c) => ({
          ...c,
          teachers: c.teachers2,
          lessons: c.lessons2,
          percentage: c.percentage2,
        }));
      }
      this.loading = false;
    },
    async setFreeHalfDays(newValue) {
      if (newValue > this.maxFreeHalfDays) {
        newValue = this.maxFreeHalfDays;
      }
      if (newValue == this.wishFreeHalfDays) {
        this.key = this.key + 1;
        return;
      }
      await this.apiPatch({
        resource: "teacher/wish",
        id: this.wish.id,
        key: "halfdays",
        value: newValue,
      });

      await this.fetchData();
    },
    async setFreeFullDays(newValue) {
      if (newValue > this.maxFreeFullDays) {
        newValue = this.maxFreeFullDays;
      }
      if (newValue == this.wishFreeFullDays) {
        this.key = this.key + 1;
        return;
      }
      await this.apiPatch({
        resource: "teacher/wish",
        id: this.wish.id,
        key: "fulldays",
        value: newValue,
      });

      await this.fetchData();
    },
    async submit() {
      await this.apiPatch({
        resource: "teacher/wish",
        id: this.wish.id,
        key: "submitted",
        value: true,
      });
      this.fetchData();
    },
    async unsubmit() {
      await this.apiPatch({
        resource: "teacher/wish",
        id: this.wish.id,
        key: "submitted",
        value: false,
      });
      this.fetchData();
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
